import 'bootstrap/dist/css/bootstrap.min.css';
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import React, { useEffect, useState } from "react";
import { Col, Container, Nav, Row } from 'react-bootstrap';
import { enviroment } from "../../enviroment";
import ApiService from "../../services/ApiService";
import { Envelope, Phone } from 'react-bootstrap-icons';

export const AllStores = () => {

  const [storeData, setStoreData] = useState([]);
  const [activeLocation, setActiveLocation] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleLocationChange = (city_id) => {
    const newLocation = storeData.find(loc => loc?.city_id === city_id);
    if (newLocation) setActiveLocation(newLocation);
  };

  useEffect(() => {
    const payload = {
      company_id: parseInt(enviroment.COMPANY_ID),
    };
    setLoading(true);
    ApiService.getAllStores(payload)
      .then((res) => {
        if (res.payload.length === 0) return;
        const removeDuplicateCityId = res.payload.filter((v, i, a) => a.findIndex(t => (t?.city_id === v?.city_id)) === i);
        setStoreData(removeDuplicateCityId);
        // remove duplicate city_id
        setActiveLocation(res.payload[0]);
      })
      .catch((err) => { })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div>Loading...</div>;

  if (storeData.length === 0) return null;

  return (
    <div className='stores-section py-3' style={{ background: '#f8f9fa' }}>
      <Container className='max-w-1200 mx-auto'>
        <h2 className='subTitleLarge' style={{
          fontSize: '22px'
        }}>Our Store</h2>
        {/* Selected Store Details */}
        {activeLocation && (
          <div className='selected-store-details bg-white rounded-4 p-0 p-md-4 mt-3' style={{
            border: '1px solid #dee2e6'
          }}>
            <Row className='align-items-center'>
              <Col md={6}>
                <div className='position-relative' style={{ height: '400px' }}>
                  <div
                    className='position-absolute w-100 h-100 rounded-4'
                    style={{
                      backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.6)), url(${activeLocation?.photo})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }}
                  />
                  <div
                    className='position-absolute  w-100 h-100 p-4 d-flex flex-column justify-content-end'
                    style={{ zIndex: 1 }}
                  >
                    <h2 className='text-white mb-4'>{activeLocation?.city_id}</h2>
                    <div className='mb-4'>
                      <h5 className='text-white-50 mb-3'>Address</h5>
                      <p className='text-white'>{activeLocation?.address}</p>
                    </div>
                    <a href="https://g.co/kgs/T1Ybj9z"
                      className='btn btn-light px-4 py-2 rounded-pill'
                      target="_blank"
                      rel="noopener noreferrer">
                      <i className='bi bi-geo-alt-fill me-2'></i>
                      Get Directions
                    </a>
                  </div>
                </div>
              </Col>
              <Col md={6} className='ps-md-5'>
                <div className='py-4 px-4 px-md-0'>
                  <h4 className='mb-4'>Contact Information</h4>
                  <div className='d-flex flex-column gap-3'>
                    <a href={`tel:${activeLocation?.contact}`}
                      className='text-decoration-none align-items-center gap-3'
                      style={{
                        display: "grid",
                        gridTemplateColumns: "30px 1fr",
                      }}
                    >
                      <div className='d-flex align-items-center justify-content-center bg-dark rounded-circle p-1' style={{
                        width: '30px',
                        height: '30px'
                      }}>
                        <Phone color='white' />
                      </div>
                      <div>
                        <p className='mb-0 text-muted'>Phone</p>
                        {/* <strong>{activeLocation?.contact}</strong> */}
                        {/* replace / with , */}
                        <strong>{activeLocation?.contact.replace(/\//g, ', ')}</strong>
                      </div>
                    </a>
                    <a href={`mailto:${activeLocation?.email}`}
                      className='text-decoration-none align-items-center gap-3'
                      style={{
                        display: "grid",
                        gridTemplateColumns: "30px 1fr",
                      }}
                    >
                      <div className='d-flex align-items-center justify-content-center bg-dark rounded-circle p-1' style={{
                        width: '30px',
                        height: '30px'
                      }}>
                        <Envelope color='white' />
                      </div>
                      <div>
                        <p className='mb-0 text-muted'>Email</p>
                        <strong>{activeLocation?.email}</strong>
                      </div>
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        )}
      </Container>
    </div>
  );
};